<template>
    <div class="mobileNavigation">
        <ul>
            <li v-for="(menu,index) in menuList" :key="index">
                <router-link :to="menu.to"
                    class="sidebar-link router-link-active"
                    :class="{'selected':$store.state.nowPage == menu.pageCode}"
                >
                    <i :class="menu.icon"></i>
                    <!-- <span class="align-middle">{{ menu.name }}</span> -->
                </router-link>
            </li>
        </ul>
    </div>

</template>
  
<script>

export default {
    name: 'mobileNavigationView',
    props:{
        menuList:{
            type:Array,
            default:[]
        }
    },
    data(){
        return {
            
        }
    },
    async created(){
        
    },
    methods: {
        
    },
};
</script>
<style scoped>

@media screen and (max-width: 572px) {
    
    .mobileNavigation > ul {
        list-style: none;
        padding: 0;
        display: flex;
        gap: 1rem;
        margin: 0;
        width: 100%;
        background-color: #ffffff;
        box-shadow: 0px 0px 8px #00000036;
        border-radius: 4px;
        justify-content: space-around;
        padding-top: .725rem;
        padding-bottom: .725rem;
    }
    .mobileNavigation .sidebar-link{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .mobileNavigation i.me-2 {
        margin:0px !important;
    }

    .mobileNavigation .router-link-active.sidebar-link.router-link-active.selected {
        background-color: #153d77;
        color: #ffffff !important;
        font-weight: 600;
    }
    .mobileNavigation .router-link-active.sidebar-link.router-link-active.selected i {
        color: #ffffff !important;
    }

    .mobileNavigation .sidebar-link, a.sidebar-link {
        padding: .25rem .725rem;
    }
}
</style>